import emailToUsername from '../../../utils/usernameHelper'

import React from 'react'

import { Box, IconButton, Paper } from '@mui/material'

import { User } from '../../../interfaces/User/UserWMS'

import { useStyles } from './styles'

import SettingsIcon from '@mui/icons-material/Settings'

import { ChipboxBox } from '../../UI/ChipboxBox'

import {
  GenericCardFooter,
  GenericCardHeader,
  GenericCardContent
} from '../../UI/GenericCard'

interface UserCardProps {
  user: User
  handleEditUser: () => void
}

export const UserCard: React.FC<UserCardProps> = ({ user, handleEditUser }) => {
  const { small } = useStyles()

  const username = user.userAlias || emailToUsername(user.userName)

  return (
    <Box component={Paper} className={small}>
      <GenericCardHeader text={username} />

      <GenericCardContent>
        <ChipboxBox
          collection={user.zones.filter(({ active }) => active)}
          keyFinder={({ zoneName }) => zoneName}
        />
      </GenericCardContent>

      <GenericCardFooter>
        <IconButton aria-label='delete' onClick={handleEditUser}>
          <SettingsIcon />
        </IconButton>
      </GenericCardFooter>
    </Box>
  )
}
